module.exports = __webpack_public_path__ + "img/usecargonegativo.5748e754.png";